import React from "react";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { Photo, TextFields, Title as TitleIcon } from "@mui/icons-material";

// The three blank contract block types. Shared by the section add-block menus,
// the document-level Add menu (empty state), and the block cards' headers.
export type BlockType = 'text' | 'field' | 'image';

export type BlockTypeEntry = {
    type: BlockType,
    label: string,
    icon: React.ReactElement,
};

export const BLOCK_TYPES: BlockTypeEntry[] = [
    { type: 'text', label: 'Text', icon: <TextFields fontSize="small" /> },
    { type: 'field', label: 'Field', icon: <TitleIcon fontSize="small" /> },
    { type: 'image', label: 'Image', icon: <Photo fontSize="small" /> },
];

// The 3-entry blank-block menu, shared by every host that offers it.
const BlockTypeMenu = ({ anchorEl, open, onSelect, onClose }: {
    anchorEl: HTMLElement | null,
    open: boolean,
    onSelect: (type: BlockType) => void,
    onClose: () => void,
}): React.ReactElement => (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
        {BLOCK_TYPES.map(bt => (
            <MenuItem key={bt.type} onClick={() => { onSelect(bt.type); onClose(); }}>
                <ListItemIcon sx={{ minWidth: 34 }}>{bt.icon}</ListItemIcon>
                <ListItemText>{bt.label}</ListItemText>
            </MenuItem>
        ))}
    </Menu>
);

export default BlockTypeMenu;
